import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {
    CommunicationDispatcherService
} from "@app/shared/communication-mapping/services/communication-dispatcher.service";
import { Subscription } from "rxjs";
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { BsModalRef } from "ngx-bootstrap";
import {
    CommunicationContainerComponent
} from "@app/shared/communication-mapping/container/communication-container.component";
import {
    AddCommunicationComponent
} from "@app/shared/communication-mapping/layouts/add-communication/add-communication.component";
import { InputModel, TemplateModel } from "@app/shared/communication-mapping/services/input-model";
import { CommunicationHelperService } from "@app/shared/communication-mapping/services/communication-helper.service";
import { TranslateService } from '@ngx-translate/core';
import {AuthService} from "@app/core";
declare var $: any;

@Component({
    selector: 'app-template-form',
    templateUrl: './template-form.component.html',
    styleUrls: ['./template-form.component.scss']
})

export class TemplateFormComponent implements OnInit, OnDestroy {

    isLoading: boolean = true;
    subscription: Subscription;
    emailTemplateList: any = [];
    smsTemplateList: any = [];
    inputModel: InputModel;
    emailTemplateId: null | number;
    smsTemplateId: null | number;
    letterTemplateId: null | number;

    sidePanelModalRef: BsModalRef;
    emailTemplateListIndexById: any = {};
    smsTemplateListIndexById: any = {};
    letterScreenLabel: string = this.translate.instant('letter.templates');
    smsScreenLabel: string = this.translate.instant('sms.templates');
    emailScreenLabel: string = this.translate.instant('email.templates');
    selectedSmsTemplate: string = this.translate.instant('sms.templates');
    selectedEmailTemplate: string = this.translate.instant('email.templates');
    selectedLetterTemplate: string = this.translate.instant('letter.templates');
    select2TemplateConfig: any;
    @Output() selectedRolesEvent = new EventEmitter<string>();
    selectedRolesList: any = [];
    @Input() roleList: any = [];
    @Input() previousRolesList: any = [];
    @Input() selectedTemplateData: any = [];
    smsModulePermission: boolean;
    noSegmentation = false;
    @Input() viewMode: boolean;

    constructor(
        private eventDispatcher: CommunicationDispatcherService,
        private modalService: SidepanelModalService,
        private helperService: CommunicationHelperService,
        private translate: TranslateService,
        private authService: AuthService,
        @Inject('confirmationBoxHelper') private confirmationBoxHelper,
        @Inject('$scope') private ajsScope,
    ) { }

    ngOnInit() {
        this.subscription = this.eventDispatcher.triggerEvent$.subscribe({
            next: (data: any) => {
                if (typeof data != 'object' || !data['actionName']) {
                    return;
                }
                const action = data['actionName'];
                /* Initial load */
                if (action == 'event:loadedData') {
                    const value = data['data'];
                    // this.setEmailTemplateList(value['emailTemplateList']);
                    // this.setSmsTemplateList(value['smsTemplateList']);
                    this.inputModel = value['inputModel'];
                    const activeEmail = this.helperService.findCurrentTemplate(this.inputModel, 'email');
                    const activeSms = this.helperService.findCurrentTemplate(this.inputModel, 'sms');
                    if (activeEmail) {
                        this.emailTemplateId = activeEmail['templateId'];
                        this.selectedEmailTemplate = activeEmail['title'];
                    }
                    if (activeSms) {
                        this.smsTemplateId = activeSms['templateId'];
                        this.selectedSmsTemplate = activeSms['title'];
                    }
                    this.isLoading = false;
                }
                if (action == 'event:updaTemplateDetails') {
                    if (this.inputModel && this.inputModel.title != null) {
                        if (this.inputModel && this.inputModel.title && this.inputModel.title.length > 0) {
                            this.selectedEmailTemplate = this.inputModel.title[0] ? this.inputModel.title[0] : this.translate.instant('email.templates');
                            this.selectedSmsTemplate = this.inputModel.title[1] ? this.inputModel.title[1] : this.translate.instant('sms.templates');
                        } else {


                            this.selectedEmailTemplate = this.translate.instant('email.templates');
                            this.selectedSmsTemplate = this.translate.instant('sms.templates');
                        }
                    }
                    if (data.value && data.value.hasOwnProperty('segmentations') && data.value.segmentations && !data.value.segmentations[0].selected && !data.value.segmentations[1].selected) {
                        this.noSegmentation = true;
                    } else {
                        this.noSegmentation = false;
                    }
                }
                if (action == 'event:cloneData') {
                    var list = data.data.list.map(obj => ({ ...obj }));
                    list.map((value) => {
                        if (data.data.segmentationDetails.sourceSegmentLevel == 1) {
                            data.data.segmentationDetails.targetValues.map(val => {
                                value.segmentationValue2 = val;
                                value.id = 0;
                                this.setTemplateDetails(value, value.communicationType,true)
                            });
                        } else {
                            data.data.segmentationDetails.targetValues.map(val => {
                                value.segmentationValue1 = val
                                value.id = 0;
                                this.setTemplateDetails(value, value.communicationType,true)
                            });
                        }
                    });
                }
            }
        });
        this.smsModulePermission  = this.authService.hasModuleAccess('Sms');

        this.select2TemplateConfig = {
            width: '100%',
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.previousRolesList) {
            let _this = this;
            let selectedOptionsList = [];
            if (changes.previousRolesList.currentValue.length) {
                this.selectedRolesEvent.emit(this.previousRolesList)
                if (typeof this.previousRolesList !== undefined) {
                    setTimeout(() => {
                        $('.notification-roles option').each(function () {
                            let optionVal: any = JSON.parse(JSON.stringify($(this).val()));
                            let splittedString = optionVal.split(': ').pop();
                            splittedString = splittedString.replace(/["']/g, "");
                            if (_this.previousRolesList.includes(splittedString)) {
                                selectedOptionsList.push(optionVal)
                            }
                        });
                        if (selectedOptionsList.length) {
                            $('.notification-roles option').select2('val', selectedOptionsList).trigger('change');
                        }
                    }, 500);
                }
            }
        }
    }

    selectedRoles(value) {
        if (value && typeof value !== undefined) {
            this.selectedRolesList = [];
            value.forEach(val => {
                let splittedString = val.split(': ').pop();
                splittedString = splittedString.replace(/["']/g, "");
                this.selectedRolesList.push(splittedString);
            });
            this.selectedRolesEvent.emit(this.selectedRolesList)
        }
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    setEmailTemplateList(data: any) {
        if (!data.length) {
            return;
        }
        data.forEach((item: any) => {
            this.emailTemplateList.push({
                id: parseInt(item.id),
                text: item.templateName
            });
            this.emailTemplateListIndexById[item.id] = item;
        });
    }

    setSmsTemplateList(data: any) {
        if (!data.length) {
            return;
        }
        data.forEach((item: any) => {
            this.smsTemplateList.push({
                id: parseInt(item.id),
                text: item.title
            });
            this.smsTemplateListIndexById[item.id] = item;
        });
    }

    showAddCommunication(commType: string) {
        const initialState = {};
        this.sidePanelModalRef = this.modalService.show(AddCommunicationComponent, {
            initialState,
            size: 'xl',
            'class': 'cs-form-add-communication',
            panelType: 'sidePanel',
        })
    }

    setTemplateDetails(templateDetails, type, isclone = false) {
        let oldTemplateId = null;
        templateDetails.title = templateDetails['templateName'] ? templateDetails['templateName'] : templateDetails['title'];
        if (type == 'email') {
            oldTemplateId = this.emailTemplateId;
            this.selectedEmailTemplate = templateDetails.title
        }
        else if (type == 'sms') {
            oldTemplateId = this.smsTemplateId;
            this.selectedSmsTemplate = templateDetails.title
        }
        else if (type == 'letter') {
            oldTemplateId = this.letterTemplateId;
        }

        const { templates, activeSegmentationValue1, activeSegmentationValue2, customerId } = this.inputModel;
        if (templates.length == 0) {
            templates.push({
                id: 0,
                communicationType: type,
                templateId: templateDetails.templateId,
                segmentationValue1: activeSegmentationValue1,
                segmentationValue2: activeSegmentationValue2,
                customerId: customerId,
                title: templateDetails['title'],
                message: templateDetails['message'],
                subject: templateDetails['subject']
            });
        } else {
            const activeItem = templates.find((item: TemplateModel) => {
                return (item.communicationType == type && item.segmentationValue1 == (isclone ? templateDetails.segmentationValue1:(this.inputModel.settings.allowSegmentation?activeSegmentationValue1:-1)) && item.segmentationValue2 == (isclone ? templateDetails.segmentationValue2:(this.inputModel.settings.allowSegmentation?activeSegmentationValue2:-1)))
            });
            if (activeItem) {
                // activeItem['id'] = parseInt(templateDetails.id);
                activeItem['segmentationValue1'] = (isclone ? templateDetails.segmentationValue1 : activeSegmentationValue1),
                    activeItem['segmentationValue2'] = (isclone ? templateDetails.segmentationValue2 : activeSegmentationValue2),
                    activeItem['templateId'] = parseInt(templateDetails.templateId);
                activeItem['message'] = templateDetails.message;
                activeItem['subject'] = templateDetails.subject;
                activeItem['title'] = templateDetails.title;

            } else {
                templates.push({
                    id: 0,
                    communicationType: type,
                    templateId: templateDetails.templateId,
                    segmentationValue1: (isclone ? templateDetails.segmentationValue1 : activeSegmentationValue1),
                    segmentationValue2: (isclone ? templateDetails.segmentationValue2 : activeSegmentationValue2),
                    customerId: customerId,
                    title: templateDetails['title'],
                    message: templateDetails['message'],
                    subject: templateDetails['subject']
                });
            }
            // this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateFormValue'], {
            //     inputModel: this.inputModel
            // });
        }
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateFormValue'], {
            inputModel: this.inputModel,
            for: isclone ? 'clone' : 'update'
        });
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateTemplateDetails'], {
            type,
            value: templateDetails,
            inputModel: this.inputModel
        });
    }

    clearConfirmation(val) {
        if (this.inputModel && this.inputModel.activeSegmentationValue1 == -1 && this.inputModel.activeSegmentationValue2 == -1) {
            this.clearValue(val);
        } else {
            if (this.inputModel.templates.find((obj: any) => (obj.segmentationValue1 == -1 && obj.segmentationValue2 == -1))) {
                this.confirmationBoxHelper.getConfirmation('Are you sure you want to remove the template?', this.ajsScope)
                    .then(() => {
                        this.clearValue(val);
                        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['save'], {})
                    }).catch(() => {
                    // this.clearValue(val);
                });
            } else {
                this.clearValue(val);
            }
        }
    }
    clearValue(val) {

        const { templates, activeSegmentationValue1, activeSegmentationValue2, customerId } = this.inputModel;
        const segmentationValue1 = this.inputModel.settings.allowSegmentation ? this.inputModel.activeSegmentationValue1 : -1;
        const segmentationValue2 = this.inputModel.settings.allowSegmentation ? this.inputModel.activeSegmentationValue2 : -1;

        const activeItem = templates.find((item: TemplateModel) => {
            return (
                item.communicationType == val &&
                (item.segmentationValue1 == segmentationValue1 || item.segmentationValue1 == (this.inputModel.settings.allowSegmentation ? this.inputModel.activeSegmentationValue1 : null)) &&
                (item.segmentationValue2 == segmentationValue2 || item.segmentationValue2 == (this.inputModel.settings.allowSegmentation ? this.inputModel.activeSegmentationValue2 : null))
            );
        });
        if (activeItem) {
            if (activeItem.communicationType == 'email') {
                this.emailScreenLabel = this.translate.instant('email.templates');
                this.selectedEmailTemplate = this.translate.instant('email.templates');
            } else if (activeItem.communicationType == 'sms') {
                this.smsScreenLabel = this.translate.instant('sms.templates');
                this.selectedSmsTemplate = this.translate.instant('sms.templates');
            }

            this.inputModel.templates = this.inputModel.templates.filter(function(item) {
                return !(item.id == activeItem.id && item.communicationType == activeItem.communicationType && item.segmentationValue1 == activeItem.segmentationValue1 && item.segmentationValue2 == activeItem.segmentationValue2) ;
            });
            this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updateFormValue'], {
                inputModel: this.inputModel,
                from: 'clearOption'
            });

        }
        // console.log("cc",val,this.inputModel)
    }

    /*onChangeTemplate(type: string, event: any) {
        let oldTemplateId = null;
        if (type == 'email') {
            oldTemplateId = this.emailTemplateId;
        }
        else if (type == 'sms') {
            oldTemplateId = this.smsTemplateId;
        }
        const { templates, activeSegmentationValue1, activeSegmentationValue2, customerId } = this.inputModel;
        if (templates.length == 0) {
            templates.push({
                id: 0,
                communicationType: type,
                templateId: event,
                segmentationValue1: activeSegmentationValue1,
                segmentationValue2: activeSegmentationValue2,
                customerId: customerId,
            });
        }
        else {
            const activeItem = templates.find((item: TemplateModel) => {
                return activeSegmentationValue1 == item.segmentationValue1
                    && activeSegmentationValue2 == item.segmentationValue2
                    && item.templateId == oldTemplateId
                    && item.communicationType == type
            });
            if (activeItem) {
                activeItem['templateId'] = event;
            }
            else {
                templates.push({
                    id: 0,
                    communicationType: type,
                    templateId: event,
                    segmentationValue1: activeSegmentationValue1,
                    segmentationValue2: activeSegmentationValue2,
                    customerId: customerId,
                });
            }
        }
        this.eventDispatcher.dispatchEvent(CommunicationDispatcherService.CONSTANTS['updatedTemplateId'], {
            type,
            value: event,
            inputModel: this.inputModel
        });
    }*/
}
